<template>
  <div class="col-xs-12 p-x-0">
    <div class="col-xs-12 p-x-0" v-if="productAmount > 1 && prodType === 'package' && adjusts.length">
      <!--<hr>-->
      <div class="inline-block" style="top: 10px">
        <label class="text-13 text-black pull-right">
          <q-checkbox v-model="adjustSame[currentProduct[schema.product.product_id]]"></q-checkbox>統一口味設定
        </label>
      </div>
      <!--<div class="inline-block" v-for="index in productAmount">{{index}}</div>-->
    </div>
    <!-- 選項 -->
    <ul class="col-xs-12 nav" v-for="pA in pAmountShow">
      <li v-if="pAmountShow > 1">
        <hr style="border-top: dashed 1px #eee;">
        <hr style="border-top: dashed 1px #eee;">
        {{pA}}. {{currentProduct[schema.product.name]}}
      </li>
      <menu-options :storeState="2"
                    :currentProduct="currentProduct"
                    prodType="package"
                    :checkPrice="checkPrice"
                    :checkAddProduct="checkAddProduct"
                    :checkAddDifProduct="checkAddDifProduct"
                    :productAmount="productAmount"
                    :optionCheck="optionCheck"
                    :show="show"
                    :productShow="productShow"
                    :adjustSame="adjustSame"
                    :pAIndex="pA"
                    :aSameCheck="aSameCheck"
                    :ref="'menu-options-' + currentProduct[schema.product.product_id] + '-index' + pA"
                    :paAdjusts="adjusts"
                    :menuJson="menuJson"
                    layout="line"
                    :clickProduct="clickProduct"
      ></menu-options>
      <!--
          :iconList="iconList"
          :pIconList="pIconList"
          :showProductIcon="showProductIcon"
          :getIcon="getIcon"
      -->
    </ul>
  </div>
</template>

<script>
// import $ from 'jquery'
import MenuOptions from './MenuOptions.vue'
import parse from '../../../../assets/js/parse-menu.js'
export default{
  props: {
    menuJson: [Object, String],
    storeState: Number,
    modalView: Boolean,
    currentProduct: [Object, Array],
    brandId: Number,
    prodType: String,
    checkPrice: Function,
    checkAddProduct: Function,
    checkAddDifProduct: Function,
    optionCheck: Object,
    productAmount: Number,
    // 顯示停賣wording用
    show: Object,
    productShow: [Boolean, Object],
    // 確認是否預設調整項目相同
    adjustSame: Object,
    isInit: Boolean,
    clickProduct: Function
  },
  data () {
    return {
      adjusts: [],
      schema: {
        category: {},
        product: {},
        icon: {},
        image: {},
        tag: {},
        adjust: {},
        option: {},
        combine: {},
        edge: {},
        common: {},
        block: {}
      },
      tags: 0,
      currentMenuJson: '',
      storeId: this.$route.params.storeId,
      productCombineIds: [],
      menu: {
        categoryList: {},
        productList: {},
        adjustList: {},
        optionList: {},
        combineList: {}
      }
    }
  },
  methods: {
    getOption (optionId) {
      return this.menu.optionList[optionId]
    },
    getAdjust (adjustId) {
      return this.menu.adjustList[adjustId]
    },
    getSessionName (type, storeId) {
      if (type === 'version') {
        return 'Nidin_' + storeId + '_menuVersion'
      } else if (type === 'menu') {
        return 'Nidin_' + storeId + '_menu'
      } else {
        return false
      }
    },
    getCurOrderInfo (index) {
      if (this.curOrderInfo) return this.curOrderInfo[index - 1]
    },
    clickAdd () {
      var add = true
      var pSchema = this.schema.product
      for (var p = 1; p <= this.pAmountShow; p++) {
        if (!this.$refs['menu-options-' + this.currentProduct[pSchema.product_id] + '-index' + p][0].clickAdd()) {
          add = false
          return add
        }
      }
      return add
    },
    init () {
      if (this.menuJson !== undefined) {
        this.currentMenuJson = this.menuJson
        this.menu.categoryList = this.currentMenuJson.category_list_json.data
        this.menu.productList = this.currentMenuJson.product_list_json.data
        this.menu.adjustList = this.currentMenuJson.adjust_list_json.data
        this.menu.optionList = this.currentMenuJson.option_list_json.data
        this.menu.combineList = this.currentMenuJson.combine_list_json.data

        this.schema.category = this.currentMenuJson.category_list_json.schema
        this.schema.product = this.currentMenuJson.product_list_json.schema
        this.schema.icon = this.currentMenuJson.product_list_json.icon_schema
        this.schema.img = this.currentMenuJson.product_list_json.img_schema
        this.schema.tag = this.currentMenuJson.product_list_json.tag_schema
        this.schema.adjust = this.currentMenuJson.adjust_list_json.schema
        this.schema.option = this.currentMenuJson.option_list_json.schema
        this.schema.combine = this.currentMenuJson.combine_list_json.schema
        this.schema.edge = this.currentMenuJson.combine_list_json.edge_schema
        this.schema.common = this.currentMenuJson.combine_list_json.common_schema
        if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema
      }
      this.initOptions()
    },
    initOptions () {
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list]
      this.adjusts = this.showAll(this.currentProduct, this.productCombineIds)
    },
    showAll (product, combines) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option

      // Data
      var adjustIds = product[pSchema.adjust_list]
      var result = []

      // Fill Up adjust.option_list with option
      for (var adjustIndex = 0; adjustIndex < adjustIds.length; adjustIndex++) {
        var adjust = parse.divideList(adjustIds, this.getAdjust)[adjustIndex]
        if (adjust) {
          adjust.activeCount = 0
          adjust.activeOptionIds = []
          for (var optionIndex = 0; optionIndex < adjust[aSchema.option_list].length; optionIndex++) {
            if (typeof adjust[aSchema.option_list][optionIndex] === 'number') {
              adjust[aSchema.option_list][optionIndex] = this.getOption(adjust[aSchema.option_list][optionIndex])
              adjust[aSchema.option_list][optionIndex].activeCount = 0
            }
          }
          adjust[aSchema.option_list].sort(function (a, b) {
            if (a[oSchema.sort] > b[oSchema.sort]) {
              return 1
            }
            if (a[oSchema.sort] < b[oSchema.sort]) {
              return -1
            }

            return 0
          })
          result.push(adjust)
        }
      }
      // 排adjust順序 (尺寸, 甜度, 溫度, 加料)
      result.push([])
      result.sort(function (a, b) {
        if (a[aSchema.sub_type] && b[aSchema.sub_type]) return b[aSchema.sub_type] - a[aSchema.sub_type]
        else return b[aSchema.sub_type] - a[aSchema.sub_type]
      })
      result.splice(-1, 1)
      return result
    }
  },
  created () {
    this.init()
  },
  computed: {
    pAmountShow () {
      if (this.aSameCheck) return 1
      else if (this.adjusts.length) return this.productAmount
      return 1
    },
    aSameCheck () {
      var pSchema = this.schema.product
      return this.adjustSame[this.currentProduct[pSchema.product_id]]
    }
  },
  components: {
    'menu-options': MenuOptions
  },
  watch: {
    currentProduct () {
      this.init()
    }
  }
}
</script>



// WEBPACK FOOTER //
// MutiProduct.vue?9c5724fc